export const validaInteiroELimitaCampo = (valor, limite, campo, setValue) => {
  const inputValue = valor
  const numericValue = inputValue.replace(/\D/g, ''); // Remove caracteres não numéricos
  const limitedValue = numericValue.slice(0, limite);
  setValue(campo, limitedValue);
};